import { useState, useEffect, useCallback } from 'react';
import {Form, InputGroup} from 'react-bootstrap';
import debounce from "lodash.debounce";
import * as consts from '../consts';

const DEFAULT_COUNTRY = consts.COUNTRIES_DATA[0];

const levelData = [
    {label: 'C Suite', value: 'c_suite'},
    {label: 'Company Head', value: 'company_head'},
    {label: 'Company Leader', value: 'company_leader'},
    {label: 'Senior Management', value: 'senior_management'},
    {label: 'Other', value: 'other'},
];

const functionData = [
    {label: 'Sales & Marketing', value: 'sales_and_marketing'},
    {label: 'Engineering', value: 'engineering'},
    {label: 'Accounting & Finance', value: 'accounting_and_finance'},
    {label: 'Legal, Risk & Compliance', value: 'legal_risk_and_compliance'},
    {label: 'Creative & Design', value: 'creative_and_design'},
    {label: 'Technology', value: 'technology'},
    {label: 'HR & Talent Acquisition', value: 'hr_and_talent_acquisition'},
    {label: 'Other', value: 'other'},
];

function MPeopleFilters(props, ref) {
    const [clearAllVisible, setClearAllVisible] = useState(false);
    const [levelValues, setLevelValues] = useState([]);
    const [functionValues, setFunctionValues] = useState([]);
    const [textValues, setTextValues] = useState({});
    const [checkValues, setCheckValues] = useState({});
    const [toggleValues, setToggleValues] = useState({});
    const [filterModel, setFilterModel] = useState({});
    const [forceFilterModel, SetForceFilterModel] = useState(false);

    useEffect(() => {
        const filterKeys = Object.keys(props.peopleFilterModel);

        var updatedTextValues = {};
        var updatedCheckValues = {};
        var updatedToggleValues = {};
        var updatedLevelValues = [];
        var updatedFunctionValues = [];

        filterKeys.map(filterKey => {
            const filterValue = props.peopleFilterModel[filterKey];


            if (filterKey === 'level') {
                if (filterValue.operator??''.toLowerCase() === 'or') {
                    updatedLevelValues = filterValue.conditions.map(e => e.filter)
                } else {
                    updatedLevelValues.push(filterValue.filter)
                }
            } else if (filterKey === 'function') {
                if (filterValue.operator??''.toLowerCase() === 'or') {
                    updatedFunctionValues = filterValue.conditions.map(e => e.filter)
                } else {
                    updatedFunctionValues.push(filterValue.filter)
                }
            } else if (filterValue.filterType === 'text') {
                if (filterValue.type === 'blank') {
                    updatedCheckValues[filterKey] = true;
                    updatedToggleValues [filterKey] = false;
                } if (filterValue.type === 'notBlank') {
                    updatedCheckValues[filterKey] = true;
                    updatedToggleValues [filterKey] = true;
                } else {
                    updatedTextValues[filterKey] = filterValue.filter
                    if ((filterKey === 'role') && (filterValue.filter??''.length > 0)) {
                        updatedCheckValues[filterKey] = true;
                        updatedToggleValues [filterKey] = true;
                    }
                }
            } else if (filterValue.filterType === 'number') {
                if ((filterValue.type === 'equals') && (parseInt(filterValue.filter) === 1)) {
                    updatedCheckValues[filterKey] = true
                } 
            } else if (filterValue.filterType === 'set') {
                if (["isphone","email"].includes(filterKey)) {
                    updatedCheckValues[filterKey] = true;
                    updatedToggleValues[filterKey] = filterValue.values.includes("true");
                } else if (["isemailprefixgeneric","isemailsuffixgeneric"].includes(filterKey)) {
                    updatedCheckValues[filterKey] = filterValue.values.includes("false");
                }
            }
        });

        setTextValues(updatedTextValues);
        setCheckValues(updatedCheckValues);
        setToggleValues(updatedToggleValues);
        setLevelValues(updatedLevelValues);
        setFunctionValues(updatedFunctionValues);

        setFilterModel(props.peopleFilterModel);
    }, [props.peopleFilterModel])

    function updateFilterModel(eDataValue, filterValue) {
        setFilterModel((prevData) => {
            if (Object.keys(filterValue).length <= 0) {
                // Remove the key from prevData
                const { [eDataValue]: _, ...rest } = prevData;
                return rest;
            }
            // Otherwise, add/update the key
            return {
                ...prevData,
                [eDataValue]: filterValue,
            }; 
        });

        SetForceFilterModel(true);
    }

    function handleLevelSelection(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;

        var levelConditions = [];

        if (eChecked) {
            levelConditions = [...levelValues, eDataValue]
        } else {
            levelConditions = levelValues.filter(e => e !== eDataValue)
        }

        var filterValue = {};
        if (levelConditions.length < levelData.length) {
            var filterConditions = [];
            levelConditions.map(e => filterConditions.push({filterType: 'text', type: 'equals', filter: e}));
            filterValue = {filterType: "text", operator: "OR", type: "contains", conditions: filterConditions};
        }

        setLevelValues(levelConditions);
        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     ['level']: filterValue,
        // }));
        updateFilterModel('level', filterValue);
    }

    function handleFunctionSelection(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;

        var functionConditions = [];

        if (eChecked) {
            functionConditions = [...functionValues, eDataValue]
        } else {
            functionConditions = functionValues.filter(e => e !== eDataValue)
        }

        var filterValue = {};
        if (functionConditions.length < functionData.length) {
            var filterConditions = [];
            functionConditions.map(e => filterConditions.push({filterType: 'text', type: 'equals', filter: e}));
            filterValue = {filterType: "text", operator: "OR", type: "contains", conditions: filterConditions};
        }

        setFunctionValues(functionConditions);
        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     ['function']: filterValue,
        // }));
        updateFilterModel('function', filterValue);
    }

    function handleTextChange(e) {
        const eDataValue = e.currentTarget.dataset.value;
        const eValue = e.target.value;
        const eCheckValue = checkValues[eDataValue]??false;
        const eToggleValue = toggleValues[eDataValue]??false;

        setTextValues((prevData) => ({
            ...prevData,
            [eDataValue]: eValue,
        }))

        handleDebouncedTextChange(eValue, eDataValue, eCheckValue, eToggleValue);
    }

    const handleDebouncedTextChange = useCallback(
        debounce((eValue, eDataValue, eCheckValue, eToggleValue) => {
            var filterValue = {}; 
            filterValue = {filterType: "text", type: "contains", filter: eValue};

            if (eDataValue === 'role') {
                if (eValue.length > 0) {
                    setCheckValues((prevData) => ({
                        ...prevData,
                        [eDataValue]: true,
                    }))

                    setToggleValues((prevData) => ({
                        ...prevData,
                        [eDataValue]: true,
                    }))
                } else if (eCheckValue) {
                    filterValue = {filterType: "text", type: eToggleValue ? "notBlank" : "blank"}
                }
            }

            // setFilterModel((prevData) => ({
            //     ...prevData,
            //     [eDataValue]: filterValue,
            // }));
            updateFilterModel(eDataValue, filterValue);
        }, 500),
        []
    );

    function handleCheckChange(e) {
        const eDataType = e.currentTarget.dataset.type;
        const eDataToggle = JSON.parse(e.currentTarget.dataset.toggle);
        const eDataValue = e.currentTarget.dataset.value;
        const eChecked = e.target.checked;
        const eTextValue = textValues[eDataValue]??'';

        var checkValue = false;
        var toggleValue = false;
        var filterValue = {}; 
        if (eDataToggle) {
            checkValue = true;
            toggleValue = eChecked;
            if (eDataType === "number") {
                filterValue = {filterType: "number", type: "equals", filter: eChecked ? 1 : 0}
            } else if (eDataType === "text") {
                filterValue = {filterType: "text", type: eChecked ? "notBlank" : "blank"}
            } else if (eDataType === 'bool') {
                filterValue = {filterType: "set", values: [eChecked ? "true" : "false"]}
            } else if (eDataType === 'loob') {
                filterValue = {filterType: "set", values: [eChecked ? "false" : "true"]}
            }
        } else if (eChecked) {
            checkValue = eChecked;
            toggleValue = eChecked;
            if (eDataType === "number") {
                filterValue = {filterType: "number", type: "equals", filter: 1}
            } else if (eDataType === "text") {
                filterValue = {filterType: "text", type: "notBlank"}
            } else if (eDataType === 'bool') {
                filterValue = {filterType: "set", values: [eChecked ? "true" : "false"]}
            } else if (eDataType === 'loob') {
                filterValue = {filterType: "set", values: [eChecked ? "false" : "true"]}
            }
        }

        if (eDataValue === 'role') {
            if (checkValue && !toggleValue) {
                setTextValues((prevData) => ({
                    ...prevData,
                    [eDataValue]: '',
                }))
            } else if (eTextValue.length > 0) {
                filterValue = {filterType: "number", type: "contains", filter: eTextValue}
            }
        }

        setCheckValues((prevData) => ({
            ...prevData,
            [eDataValue]: checkValue,
        }))

        setToggleValues((prevData) => ({
            ...prevData,
            [eDataValue]: toggleValue,
        }))

        // setFilterModel((prevData) => ({
        //     ...prevData,
        //     [eDataValue]: filterValue,
        // }));
        updateFilterModel(eDataValue, filterValue);
    }

    useEffect(() => {
        if (forceFilterModel) {
            props.pplfm(filterModel)
            SetForceFilterModel(false);
        }
    }, [forceFilterModel])

    function resetFilterModel() {
        props.pplfm({});
        
        setLevelValues([]);
        setFunctionValues([]);
        setFilterModel({});
        setCheckValues({});
        setTextValues({});
        setToggleValues({});
    }

    useEffect(() => {
        if (clearAllVisible) {
            resetFilterModel()
        }
    }, [props.forceReset])

    useEffect(() => {
        const cav = (levelValues.length > 0) || (functionValues.length > 0) || (Object.keys(textValues).filter(key => (textValues[key] !== '')).length > 0) || (Object.keys(checkValues).filter(key => checkValues[key]).length > 0);
        setClearAllVisible(cav);
        props.pcav("people",cav);
    }, [levelValues, functionValues, textValues, checkValues])

    return (
        <div className="p-2 border border-gray">
            <div className="mb-3 d-flex flex-row">
                <div style={{fontWeight: "700", fontSize: "13px"}}><i className="me-1 bi bi-people"></i>PEOPLE</div>
                <div className={`ms-auto ${clearAllVisible && false ? 'd-flex' : 'd-none'}`} style={{color: "#ff3f6c", fontWeight: "700", fontSize: "13px", cursor: "pointer"}} onClick={resetFilterModel}>CLEAR ALL</div>
            </div>
            <Form id="frmMCatalogFilters" autocomplete="off">
                <div className="mb-3">
                    <Form.Label id="lblName" for="ctlName">Name</Form.Label>
                    <InputGroup>
                        <Form.Control size="sm" id="ctlName" data-value="name" data-toggle={false} data-type="text" className="border border-primary" type="search" value={textValues.name??''} onChange={handleTextChange}></Form.Control>
                    </InputGroup>
                </div>
                <div className="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlRole" data-value="role" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.role} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblRole" for="ctlRole">Role/Title</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsRole" data-value="role" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.role} disabled={!checkValues.role} onChange={handleCheckChange} />
                </div>
                <div className="mb-3">
                    <InputGroup>
                        <Form.Control size="sm" id="ctlRole" data-value="role" data-toggle={false} data-type="text" className="border border-primary" type="search" value={textValues.role??''} onChange={handleTextChange} disabled={false}></Form.Control>
                    </InputGroup>
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlPhone" data-value="isphone" data-toggle={false} data-type="bool" className="border border-primary" type="checkbox" checked={checkValues.isphone} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblPhone" for="ctlPhone">Phone</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsPhone" data-value="isphone" data-toggle={true} data-type="bool" className="ms-auto" type="switch" checked={toggleValues.isphone} disabled={!checkValues.isphone} onChange={handleCheckChange} />
                </div>
                <div class="d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlEmail" data-value="email" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.email} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblEmail" for="ctlEmail">Email</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlIsEmail" data-value="email" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.email} disabled={!checkValues.email} onChange={handleCheckChange} />
                </div>
                <div class="ms-3 d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlExcludeGenericPrefix" data-value="isemailprefixgeneric" data-toggle={false} data-type="loob" className="border border-primary" type="checkbox" checked={checkValues.isemailprefixgeneric} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblExcludeGenericPrefix" for="ctlExcludeGenericPrefix">Exclude Generic Prefix</Form.Check.Label>
                    </Form.Check>
                </div>
                <div class="ms-3 d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlExcludeGenericSuffix" data-value="isemailsuffixgeneric" data-toggle={false} data-type="loob" className="border border-primary" type="checkbox" checked={checkValues.isemailsuffixgeneric} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblExcludeGenericSuffix" for="ctlExcludeGenericSuffix">Exclude Generic Suffix</Form.Check.Label>
                    </Form.Check>
                </div>
                <div class="mb-2 d-flex flex-row">
                    <Form.Check>
                        <Form.Check.Input id="ctlLinkedIn" data-value="linkedin" data-toggle={false} data-type="text" className="border border-primary" type="checkbox" checked={checkValues.linkedin} onChange={handleCheckChange} />
                        <Form.Check.Label id="lblLinkedIn" for="ctlLinkedIn">LinkedIn</Form.Check.Label>
                    </Form.Check>
                    <Form.Check id="ctlLinkedIn" data-value="linkedin" data-toggle={true} data-type="text" className="ms-auto" type="switch" checked={toggleValues.linkedin} disabled={!checkValues.linkedin} onChange={handleCheckChange} />
                </div>
                <div className="mb-1">
                    <Form.Label id="lblLevelContainer" for="ctlLevelContainer">Level</Form.Label>
                </div>
                <div id="divLevelContainer" className='mb-3 p-1 rounded border border-1 border-primary'>
                    {levelData.map((row, index) => { return (
                        <Form.Check id={`level-${index}`} >
                            <Form.Check.Input className="border border-1 border-primary" data-value={row.value} type="checkbox" checked={levelValues.includes(row.value)} onChange={handleLevelSelection} />
                            <Form.Check.Label>{row.label}</Form.Check.Label>
                        </Form.Check>
                        )}
                    )}
                </div>
                <div className="mb-1">
                    <Form.Label id="lblFunctionContainer" for="ctlFunctionContainer">Function</Form.Label>
                </div>
                <div id="divFunctionContainer" className='mb-3 p-1 rounded border border-1 border-primary'>
                    {functionData.map((row, index) => { return (
                        <Form.Check id={`function-${index}`} >
                            <Form.Check.Input className="border border-1 border-primary" data-value={row.value} type="checkbox" checked={functionValues.includes(row.value)} onChange={handleFunctionSelection} />
                            <Form.Check.Label>{row.label}</Form.Check.Label>
                        </Form.Check>
                        )}
                    )}
                </div>
            </Form>
        </div>
    )
}

export default MPeopleFilters;